import { render, staticRenderFns } from "./HandleProductGroupSidebar.vue?vue&type=template&id=2613c074&scoped=true&"
import script from "./HandleProductGroupSidebar.vue?vue&type=script&lang=js&"
export * from "./HandleProductGroupSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HandleProductGroupSidebar.vue?vue&type=style&index=0&id=2613c074&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2613c074",
  null
  
)

export default component.exports